<template>
    <div id="single-contact-sidebar" class="sidebar single-contact-sidebar" v-bind:class="{ closeSidebar: !collapseSidebar }">
        <div class="white-box mb-4">
            <div class="d-flex align-items-center">
                <h5 class="sibebar-title text-left text-black mr-auto">{{ $t('profile') }}</h5>
            </div>
            <div v-if="contact !== null">
                <div class="d-flex mb-3" v-if="contact.attributes['facebook-id'] !== undefined && contact.attributes['facebook-id'] != null">
                    <div class="connector-icon mr-2 facebook-connector">
                        <font-awesome-icon class="text-white" :icon="['fab', 'facebook-f']" />
                    </div>
                    <p class="mr-2 mb-0 profile-name text-left">{{ contact.attributes['facebook-name'] }}</p>
                </div>
                <div class="d-flex mb-3" v-if="contact.attributes.email != null">
                    <div class="connector-icon mr-2 innactive email">
                        <font-awesome-icon class="icon text-white" :icon="['fas', 'envelope']" />
                    </div>
                    <p class="mr-2 mb-0 profile-name text-left"><a class="contact-data" :href="'mailto:'+ contact.attributes.email" target="_blank">{{ contact.attributes.email }}</a></p>
                    <!-- Chose main information if contact has multiple one, intergration
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="facebook-2" name="main-account-fb" class="custom-control-input">
                        <label class="custom-control-label" for="facebook-2">Pricipal</label>
                    </div>-->
                </div>
            </div>
            <div class="d-flex mb-3" v-if="contact !== null && contact.attributes['phone-number'] != null">
                <div class="connector-icon sms-connector mr-2 innactive sms">
                    <font-awesome-icon class="icon text-white" :icon="['fas', 'mobile-alt']" />
                </div>
                <div class="overflow-hidden">
                    <p class="mr-2 mb-0 profile-name text-left"><a class="contact-data" :href="`tel:${contact.attributes['phone-number']}`">{{ formatPhoneNumber(contact.attributes["phone-number"]) }}</a></p>
                    <p v-if="isArchived" class="mb-0 fs-14 text-left text-darker-grey font-nunito-italic">{{ $t('archived-contact') }}</p>
                </div>
                <!-- Chose main information if contact has multiple one, intergration
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="number-1" name="main-account-number" class="custom-control-input" checked>
                    <label class="custom-control-label" for="number-1">Pricipal</label>
                </div>
                -->
            </div>
            <div v-if="contact !== null && !isFacebookContact" class="d-flex flex-column">
                <button type="button" class="btn btn-outline-primary rounded-pill style-btn" v-b-modal.form-edit-contact>
                    {{ $t('edit') }}
                </button>
                <button
                    v-if="isArchived"
                    type="button"
                    class="btn btn-outline-primary rounded-pill style-btn mt-2"
                    :disabled="updating"
                    @click="restoreContact()"
                >
                    {{ $t('restore') }}
                </button>
                <button
                    v-else
                    type="button"
                    class="btn btn-outline-danger rounded-pill style-btn mt-2"
                    :disabled="updating"
                    @click="archiveContact()"
                >
                    {{ $t('archive') }}
                </button>
                <form-edit-contact v-bind:contact="contact"></form-edit-contact>
            </div>
        </div>
        <div class="white-box mb-4 tags-sidebar">
            <contact-tags></contact-tags>
        </div>
        <div class="white-box note-sidebar">
            <contact-notes></contact-notes>
        </div>
    </div>
</template>
<script>

// Internal componants
import ContactNotes    from './ContactNotes.vue';
import ContactTags     from './ContactTags.vue';
import FormEditContact from '../contacts/FormEditContact.vue';
import Alert           from '../../../helpers/Alert.js';

// External libraries
import {
    mapState,
    mapActions
} from 'vuex';
import moment from 'moment';
import { formatPhoneNumber } from '@/libraries/PhoneNumber';

export default {
    components: {
        FormEditContact,
        ContactNotes,
        ContactTags
    },

    props: [
        'collapseSidebar',
        'contactTags'
    ],

    data () {
        return { updating: false };
    },

    computed: {
        ...mapState('core/contacts', {
            contact: 'single',
        }),

        isArchived () {
            return this.contact !== null && this.contact.attributes['deleted-at'] !== null;
        },

        isFacebookContact () {
            return this.contact.attributes['facebook-id'] !== undefined && this.contact.attributes['facebook-id'] !== null;
        }
    },

    methods: {
        formatPhoneNumber,

        ...mapActions('core/contacts', [
            'patch'
        ]),

        /**
         * Archive the contact
         */
        archiveContact () {
            const contactId = this.contact.id;

            this.$dialog.confirm({
                title:       this.$t('archive-contact'),
                html:        this.$t('archive-contact-details'),
                centerText:  true,
                confirmText: this.$t('archive-contact'),
                danger:      true,
                onConfirm:   () => this.patch({
                    id:         contactId,
                    attributes: { 'deleted-at': moment().format() }
                })
            })
                .then((confirmed) => {
                    if (confirmed) {
                        Alert.success(this.$i18n.t('contact-is-archived'));
                    }
                })
                .catch(() => {
                    Alert.fail(this.$i18n.t('default-error'));
                });
        },

        /**
         * Restore the archived contact
         */
        restoreContact () {
            this.updating = true;

            this.patch({
                id:         this.contact.id,
                attributes: { 'deleted-at': null }
            })
                .then(() => {
                    Alert.success(this.$i18n.t('contact-unarchived'));
                })
                .catch(() => {
                    Alert.fail(this.$i18n.t('default-error'));
                })
                .finally(() => {
                    this.updating = false;
                });
        }
    }
};
</script>
